import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { AuthContextProvider } from './util/AuthContext';
// import {HelmetProvider} from 'react-helmet'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>

    <BrowserRouter>
    <AuthContextProvider>
      

    <App />
      
    </AuthContextProvider>
    </BrowserRouter>
  </React.StrictMode>
);

